import type { PiniaPluginContext } from 'pinia'

interface IResettableStore {
  $id: string
  $reset: () => void
}

const stores = new Map<string, IResettableStore>()

export const storeRegistryPlugin = ({ store }: PiniaPluginContext) => {
  stores.set(store.$id, store)
}

export const resetStore = (id: string) => {
  stores.get(id)?.$reset()
}

export const resetAllStores = () => {
  stores.forEach(store => store.$reset())
}
